export const DASHBOARD_LAYOUT = [
  ['topNotifications'],
  ['welcome1'],
  ['welcome2'],
  ['welcomeOnboarding'],
  ['welcomeAppEngagement'],
  ['europeanLanguageNotification'],
  ['onboardingChecklist'],
  ['onboardingArticles'],
  ['notifications'],
  ['review'],
  ['themeSetupStatus', 'subscriptionStatus'],
  ['optionInEmail'],
  ['menuDashboard1'],
  ['menuDashboardAppEngagement'],
  ['syncHookStatus'],
  ['gettingStartedVideos'],
  ['guideToKnowledgeBase'],
  ['guideToKnowledgeBaseAppEngagement'],
  ['recommendedApps'],
  ['helpCenter'],
  ['feedback']
];

export const OnboardingNewFeatureStep = [
  'old-customer-welcome',
  'old-customer-feature-updates',
  'old-customer-recommendation-widget',
  'old-customer-add-ons',
  'old-customer-setup-theme',
  'old-customer-done-onboarding'
];

export const DASHBOARD_LAYOUT_TOP = [
  ['marketingBanner'],
  ['welcome3'],
  ['upgradeTurbo'],
  ['notifications'],
  ['quickStartGuide'],
  ['crossSellUpSell']
];

export const DASHBOARD_LAYOUT_FIRST_COLUMN = [
  ['subscriptionStatus', 'themeSetupStatus'],
  ['getSupport'],
  ['optionInEmail']
];

export const DASHBOARD_LAYOUT_SECOND_COLUMN = [
  ['syncHookStatus'],
  ['changeLogs'],
  ['recommendedApps']
];

export const DashboardDismissChoices = [
  {
    label: 'AdminHTML.Dashboard.BlockCanDismiss.feedback_OptionUserful',
    value: 'userful'
  },
  {
    label: 'AdminHTML.Dashboard.BlockCanDismiss.feedback_OptionNotUseful',
    value: 'notUseful'
  },
  {
    label: 'AdminHTML.Dashboard.BlockCanDismiss.feedback_OptionAppearOften',
    value: 'appearOften'
  }
];

export const DASHBOARD_BLOCKS_DEFAULT = {
  marketingBanner: true,
  welcome3: true,
  notifications: true,
  quickStartGuide: true,
  syncHookStatus: true,
  crossSellUpSell: true,
  changeLogs: true,
  subscriptionStatus: true,
  themeSetupStatus: true,
  getSupport: true,
  recommendedApps: true,
  optionInEmail: true,
  welcome1: true,
  welcome2: true,
  onboardingChecklist: true,
  onboardingArticles: false,
  menuDashboard1: true,
  menuDashboard2: true,
  gettingStartedVideos: true,
  guideToKnowledgeBase: true,
  review: true,
  helpCenter: true,
  appInsight: true,
  boostInsightHub: true,
  marketingMiddleBanner: true,
  planSubscription: true,
  csatRating: true
};
